<script setup lang="ts"></script>

<template>
  <main />
</template>
